import { PaginatedResponse, APIObject, DatabaseObject } from "./class";
import type {
  AggregateQuery,
  Filters,
  Aggregate,
  PaginatedFunction,
  Relationship,
  AggregateResponse,
  AuthUser,
  AuthCompany,
  FiltersDisplay,
} from "./class";
import { Company } from "./company";
import { User } from "./user";
import { DateObject } from "./datetime";
import { DBFile } from "./file";
import { FunctionalLocation } from "./functional-location";
import { Workorder } from "./workorder";
import { Tactic, TacticOperation } from "./tactic";
import {
  AssetManagementPlan,
  AssetManagementPlanMaster,
  AssetManagementPlanMasterApprovalStage,
  AssetManagementPlanMasterApprover,
  AssetManagementPlanApproval,
  IndividualAssetManagementPlan,
  RACIRole,
  RACIData,
  RACITask,
  FLOCBoundary,
  RiskRegisterLink,
  WorkManagementMetricsLink,
  ReliabilityMetricsLink,
} from "./asset-management-plan";
import { Role, PlannerGroup, CostCenter, AssetClass } from "./config";

// Relationship definitions
User.relationships = {
  company: {
    dataClass: Company,
    backref: null,
  },
};

Tactic.relationships = {
  tactic_operations: {
    dataClass: TacticOperation,
    backref: "tactic",
    jsonify: true,
  },
};

TacticOperation.relationships = {
  tactic: {
    dataClass: Tactic,
    backref: "tactic_operations",
  },
};

AssetManagementPlanMaster.relationships = {
  asset_management_plans: {
    dataClass: AssetManagementPlan,
    backref: "asset_management_plan_master",
  },
  approval_stages: {
    dataClass: AssetManagementPlanMasterApprovalStage,
    backref: "asset_management_plan_master",
  },
  latest_revision: {
    dataClass: AssetManagementPlan,
    backref: null,
  },
  latest_published_revision: {
    dataClass: AssetManagementPlan,
    backref: null,
  },
};

AssetManagementPlan.relationships = {
  asset_management_plan_master: {
    dataClass: AssetManagementPlanMaster,
    backref: "asset_management_plans",
  },
  approvals: {
    dataClass: AssetManagementPlanApproval,
    backref: "asset_management_plan",
  },
  individual_asset_management_plans: {
    dataClass: IndividualAssetManagementPlan,
    backref: "asset_management_plan",
    jsonify: true,
  },
  raci_tasks: {
    dataClass: RACITask,
    backref: "asset_management_plan",
    jsonify: true,
  },
  raci_roles: {
    dataClass: RACIRole,
    backref: "asset_management_plan",
    jsonify: true,
  },
  raci_data: {
    dataClass: RACIData,
    backref: "asset_management_plan",
    jsonify: true,
  },
  floc_boundaries: {
    dataClass: FLOCBoundary,
    backref: "asset_management_plan",
    jsonify: true,
  },
  risk_register_links: {
    dataClass: RiskRegisterLink,
    backref: null,
    jsonify: true,
  },
  work_management_metrics_links: {
    dataClass: WorkManagementMetricsLink,
    backref: null,
    jsonify: true,
  },
  reliability_metrics_links: {
    dataClass: ReliabilityMetricsLink,
    backref: null,
    jsonify: true,
  },
};

AssetManagementPlanMasterApprovalStage.relationships = {
  asset_management_plan_master: {
    dataClass: AssetManagementPlanMaster,
    backref: "approval_stages",
  },
  approvers: {
    dataClass: AssetManagementPlanMasterApprover,
    backref: "stage",
  },
};

AssetManagementPlanMasterApprover.relationships = {
  stage: {
    dataClass: AssetManagementPlanMasterApprovalStage,
    backref: "approvers",
  },
};

AssetManagementPlanApproval.relationships = {
  asset_management_plan: {
    dataClass: AssetManagementPlan,
    backref: "approvals",
  },
};

IndividualAssetManagementPlan.relationships = {
  asset_management_plan: {
    dataClass: AssetManagementPlan,
    backref: "individual_asset_management_plans",
  },
};

RACITask.relationships = {
  asset_management_plan: {
    dataClass: AssetManagementPlan,
    backref: "raci_tasks",
  },
};

RACIRole.relationships = {
  asset_management_plan: {
    dataClass: AssetManagementPlan,
    backref: "raci_roles",
  },
};

RACIData.relationships = {
  asset_management_plan: {
    dataClass: AssetManagementPlan,
    backref: "raci_data",
  },
};

FLOCBoundary.relationships = {
  asset_management_plan: {
    dataClass: AssetManagementPlan,
    backref: "floc_boundaries",
  },
  functional_location: {
    dataClass: FunctionalLocation,
    backref: null,
  },
};

FunctionalLocation.relationships = {
  asset_class: {
    dataClass: AssetClass,
    backref: null,
  },
};

export {
  Filters,
  FiltersDisplay,
  APIObject,
  AggregateQuery,
  Aggregate,
  AggregateResponse,
  PaginatedResponse,
  Relationship,
  DatabaseObject,
  PaginatedFunction,
  Company,
  User,
  AuthUser,
  AuthCompany,
  DateObject,
  DBFile,
  FunctionalLocation,
  Workorder,
  Tactic,
  TacticOperation,
  AssetManagementPlan,
  AssetManagementPlanMaster,
  AssetManagementPlanMasterApprovalStage,
  AssetManagementPlanMasterApprover,
  AssetManagementPlanApproval,
  IndividualAssetManagementPlan,
  FLOCBoundary,
  RACIRole,
  RACIData,
  RACITask,
  RiskRegisterLink,
  WorkManagementMetricsLink,
  ReliabilityMetricsLink,
  Role,
  PlannerGroup,
  CostCenter,
  AssetClass,
};
